/**
 * Faz 3 - küçük, paylaşılan sayısal giriş UX yardımcıları.
 *
 * Tüm admin ilan formu sayı alanları (Fiyat, m² Fiyatı, Alan (m²) ve "Mülk
 * Özellikleri" içindeki sayısal alanlar - m² Brüt/Net, Kat Sayısı, Gabari vb.)
 * TEK bir yerden bu mantığı kullanır (bkz. components/ui/numeric-input.js) -
 * mantık hiçbir alanda tekrar yazılmaz.
 *
 * Backend veri tipleri DEĞİŞMEDİ: bu sadece EKRANDA ne gösterildiğini ve
 * kullanıcı yazarken form state'ine hangi TEMİZ rakam dizisinin yazıldığını
 * belirler - API'ye giden değer her zaman düz bir sayı(/rakam dizisi) olur,
 * asla "5.000.000" gibi biçimlendirilmiş bir string olmaz.
 */

/** Herhangi bir ham değeri (sayı veya string, null/undefined dahil) güvenli bir string'e çevirir. */
export const toCleanNumericString = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "number") return String(Math.trunc(value));
  return String(value);
};

/**
 * Kullanıcının yazdığı veya yapıştırdığı HER ham değeri temizler:
 * - rakam dışı her karakteri (nokta, virgül, harf, boşluk...) atar
 * - baştaki sıfırları tamamen siler: "055" -> "55", tek başına "0" veya "0005" ->
 *   sırasıyla "" / "5" (ilk rakam hiçbir zaman 0 olarak kalmaz)
 * - düzenleme sırasında boş değer her zaman geçerlidir ("" döner, zorla 0 yazılmaz)
 */
export const sanitizeNumericDigits = (raw) =>
  (raw || "")
    .replace(/[^\d]/g, "")
    .replace(/^0+/, "");

/**
 * Temiz bir rakam dizisini Türkçe binlik ayraçla gösterime çevirir
 * (ör. "5000000" -> "5.000.000"). Sadece EKRANDA kullanılır - form state'inde
 * veya API'ye giden payload'da asla nokta bulunmaz.
 */
export const formatTurkishThousands = (digits) => (digits ? Number(digits).toLocaleString("tr-TR") : "");
